import { CoreEnums } from '@/utils/domain/constants';
import BaseFieldHandler from '../BaseFieldHandler';
import { checkLocationDistance, mapFieldLocationFilters } from '../utils';

const { FormFieldType, FormFieldStringType } = CoreEnums;

export default class BasicFieldHandler extends BaseFieldHandler {
  static supportedTypes = [
    FormFieldStringType.Boolean,
    FormFieldType.Boolean,
    FormFieldStringType.Location,
    FormFieldType.Location,
    FormFieldStringType.GoToAction,
    FormFieldType.GoToAction,
  ];

  handle() {
    const { type } = this.baseConfig;

    const handlers = {
      [FormFieldStringType.Boolean]: () => this.handleBoolean(),
      [FormFieldType.Boolean]: () => this.handleBoolean(),
      [FormFieldStringType.Location]: () => this.handleLocation(),
      [FormFieldType.Location]: () => this.handleLocation(),
      [FormFieldStringType.GoToAction]: () => this.handleGoToAction(),
      [FormFieldType.GoToAction]: () => this.handleGoToAction(),
    };

    const handler = handlers[type];
    if (!handler) {
      throw new Error(`Unsupported basic field type: ${type}`);
    }

    return handler();
  }

  handleBoolean() {
    const config = this.getBaseConfig();

    return {
      ...config,
      type: 'switch',
      colon: false,
      rules: [{ required: true }],
      labelCol: { lg: config.isLongText ? 22 : 12 },
      wrapperCol: { lg: config.isLongText ? 2 : 12 },
      style: {
        flexDirection: 'row',
        alignItems: 'center',
        paddingBottom: '1.34375em',
      },
    };
  }

  handleLocation() {
    const config = this.getBaseConfig();
    const { filters = [], isCurrentUserLocationEnabled } = this.baseConfig;
    const locationFilters = mapFieldLocationFilters(filters);

    return {
      ...config,
      type: 'location',
      isCurrentUserLocationEnabled,
      ...(locationFilters.length > 0 && {
        locationFilters,
        rules: [
          ...config.rules,
          () => ({
            validator(_, location) {
              return checkLocationDistance(location, locationFilters);
            },
          }),
        ],
      }),
    };
  }

  handleGoToAction() {
    const { isDetails } = this.fieldState;
    const { id, displayText, confirmationQuestion } = this.baseConfig;

    return {
      id,
      displayText,
      type: 'goToAction',
      knownType: this.baseConfig.type,
      locale: false,
      disabled: isDetails,
      ...(confirmationQuestion > 0 && { confirmationQuestion: true }),
      ...this.getCommonFormRouteProps(),
    };
  }
}
